/* ============================================================
   NELLA'S HAIR — Brand JS
   Color Filter | Frequently Bought Together | Reveal Animations
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll Reveal ──────────────────────────────────────── */
  function initReveal() {
    const els = document.querySelectorAll('[data-nella-reveal]');
    if (!els.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach((el) => obs.observe(el));
  }

  /* ── Color Filter Bar ──────────────────────────────────── */
  function initColorFilter() {
    const chips = document.querySelectorAll('.nella-color-chip');
    if (!chips.length) return;

    chips.forEach((chip) => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = chip.classList.contains('active');

        // deactivate all
        chips.forEach((c) => c.classList.remove('active'));

        if (!isActive) {
          chip.classList.add('active');
          const color = chip.dataset.color;
          filterProductsByColor(color);
        } else {
          filterProductsByColor(null);
        }
      });
    });
  }

  function filterProductsByColor(color) {
    const cards = document.querySelectorAll('[data-product-color]');
    if (!cards.length) return;

    cards.forEach((card) => {
      if (!color) {
        card.style.display = '';
        return;
      }
      const cardColors = (card.dataset.productColor || '').toLowerCase().split(',');
      const match = cardColors.some((c) => c.trim() === color.toLowerCase());
      card.style.display = match ? '' : 'none';
    });

    // update visible count
    const countEl = document.querySelector('.nella-filter-count');
    if (countEl) {
      const visible = document.querySelectorAll('[data-product-color]:not([style*="none"])').length;
      countEl.textContent = color ? `${visible} result${visible !== 1 ? 's' : ''}` : '';
    }
  }

  /* ── Frequently Bought Together ─────────────────────────── */
  function initFBT() {
    const fbt = document.querySelector('.nella-fbt');
    if (!fbt) return;

    const checkboxes = fbt.querySelectorAll('.nella-fbt__checkbox input[type="checkbox"]');
    const totalEl = fbt.querySelector('.nella-fbt__total span');
    const addAllBtn = fbt.querySelector('.nella-fbt__add-all');

    function updateTotal() {
      let total = 0;
      checkboxes.forEach((cb) => {
        if (cb.checked) {
          const price = parseFloat(cb.dataset.price || 0);
          total += price;

          const imgEl = fbt.querySelector(`.nella-fbt__product-img[data-variant-id="${cb.value}"]`);
          if (imgEl) imgEl.classList.add('selected');
        } else {
          const imgEl = fbt.querySelector(`.nella-fbt__product-img[data-variant-id="${cb.value}"]`);
          if (imgEl) imgEl.classList.remove('selected');
        }
      });

      if (totalEl) {
        totalEl.textContent = formatMoney(total);
      }

      if (addAllBtn) {
        const selectedCount = Array.from(checkboxes).filter((cb) => cb.checked).length;
        addAllBtn.textContent = selectedCount > 1
          ? `Add All ${selectedCount} to Cart — ${formatMoney(total)}`
          : 'Add to Cart';
      }
    }

    checkboxes.forEach((cb) => {
      cb.addEventListener('change', updateTotal);
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', async () => {
        const items = [];
        checkboxes.forEach((cb) => {
          if (cb.checked) {
            items.push({ id: parseInt(cb.value), quantity: 1 });
          }
        });

        if (!items.length) return;

        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Adding…';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (res.ok) {
            addAllBtn.textContent = 'Added!';
            addAllBtn.style.background = '#22c55e';
            setTimeout(() => {
              updateTotal();
              addAllBtn.disabled = false;
              addAllBtn.style.background = '';
              // open cart drawer if available
              document.dispatchEvent(new CustomEvent('cart:open'));
            }, 1400);
          } else {
            throw new Error('Add to cart failed');
          }
        } catch (err) {
          addAllBtn.textContent = 'Try Again';
          addAllBtn.disabled = false;
        }
      });
    }

    updateTotal();
  }

  /* ── Shop By Style Tabs ──────────────────────────────────── */
  function initStyleTabs() {
    const tabs = document.querySelectorAll('.nella-tab-btn');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        const target = tab.dataset.tab;
        const panels = document.querySelectorAll('[data-tab-panel]');
        panels.forEach((p) => {
          p.style.display = p.dataset.tabPanel === target ? '' : 'none';
        });
      });
    });

    // activate first tab
    if (tabs[0]) tabs[0].click();
  }

  /* ── FAQ Accordion ──────────────────────────────────────── */
  function initFAQ() {
    const items = document.querySelectorAll('.nella-faq__item');
    if (!items.length) return;

    items.forEach((item) => {
      const btn = item.querySelector('.nella-faq__question');
      if (!btn) return;

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        // close all
        items.forEach((i) => i.classList.remove('open'));

        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Newsletter Form ─────────────────────────────────────── */
  function initNewsletter() {
    const form = document.querySelector('.nella-newsletter__form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const emailInput = form.querySelector('input[type="email"]');
      const btn = form.querySelector('.nella-newsletter__btn');
      if (!emailInput || !emailInput.value) return;

      btn.disabled = true;
      btn.textContent = 'Subscribing…';

      // Shopify newsletter form submission
      const formData = new FormData();
      formData.append('contact[email]', emailInput.value);
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');

      try {
        await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData,
        });
        btn.textContent = 'You\'re in! ✓';
        btn.style.background = '#22c55e';
        emailInput.value = '';
      } catch {
        btn.textContent = 'Subscribe';
        btn.disabled = false;
      }
    });
  }

  /* ── Product Card Swatch Switcher ───────────────────────── */
  function initCardSwatches() {
    document.querySelectorAll('.nella-product-card').forEach((card) => {
      const swatches = card.querySelectorAll('.nella-swatch');
      const img = card.querySelector('.nella-product-card__img');

      swatches.forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => {
          swatches.forEach((s) => s.classList.remove('active'));
          swatch.classList.add('active');

          if (img && swatch.dataset.image) {
            img.src = swatch.dataset.image;
          }
        });
      });
    });
  }

  /* ── Money Formatter ─────────────────────────────────────── */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `$${amount} CAD`;
  }

  /* ── Promo Bar Dismiss ───────────────────────────────────── */
  function initPromoBanner() {
    const banner = document.querySelector('.nella-promo-banner');
    const dismiss = banner && banner.querySelector('[data-dismiss]');
    if (!dismiss) return;

    dismiss.addEventListener('click', () => {
      banner.style.display = 'none';
      sessionStorage.setItem('nella-promo-dismissed', '1');
    });

    if (sessionStorage.getItem('nella-promo-dismissed')) {
      banner.style.display = 'none';
    }
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    initReveal();
    initColorFilter();
    initFBT();
    initStyleTabs();
    initFAQ();
    initNewsletter();
    initCardSwatches();
    initPromoBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // re-init on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
